import React from 'react';
import { FormatShapeDto } from '../types';

export interface ProductTableFormatShapeSelectorProps {
	availableFormatShape: FormatShapeDto[];
	selectedFormatShapeId: string | null;
	changeSelectedFormatShape: (uom: FormatShapeDto) => void;
}

function ProductTableFormatShapeSelector(props: ProductTableFormatShapeSelectorProps) {
	const { availableFormatShape, selectedFormatShapeId, changeSelectedFormatShape } = props;
	const showFormatShapeSelector = availableFormatShape.length > 1;

	return showFormatShapeSelector ? (
		<>
			<div className="roc-make-selection">
				<h4 className="roc-make-selection__title">Make Your Selections:</h4>
				<div className="roc-make-selection__options-wrap">
					{availableFormatShape.map((formatShape) => {
						{
							return (
								<div className="roc-make-selection__options" key={'input-' + formatShape.id}>
									<label htmlFor="format-shape-select">
										<input
											id="format-shape-select"
											type="radio"
											name="format-shape-select"
											value={formatShape.id}
											checked={formatShape.id == selectedFormatShapeId}
											onChange={(e) => {
												const selected = availableFormatShape.find(
													(u) => u.id == e.currentTarget.value,
												);

												if (selected != undefined) {
													changeSelectedFormatShape(selected);
												}
											}}
										/>
										{formatShape.name}
									</label>
								</div>
							);
						}
					})}
				</div>
			</div>
		</>
	) : null;
}

export default ProductTableFormatShapeSelector;
